import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const DATA = [
  { name: "Bonding Curve", value: 80, color: "#00F0FF" },
  { name: "Raydium LP (Migration)", value: 20, color: "#FFD700" },
];

const STATS = [
  { label: "LAUNCH TYPE", value: "FAIR LAUNCH", suffix: "ON · PUMP.FUN" },
  { label: "BLOCKCHAIN", value: "SOLANA", suffix: "SPL TOKEN" },
  { label: "TOTAL SUPPLY", value: "1,000,000,000", suffix: "$LA28" },
];

export default function Tokenomics() {
  return (
    <section
      id="tokenomics"
      data-testid="tokenomics-section"
      className="relative py-28 sm:py-36 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="font-mono text-xs tracking-[0.32em] text-[#00F0FF] mb-5">
            // 02 · TOKENOMICS
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1] text-white">
            Fair launch. <br />
            <span className="text-white/70">Built to spread.</span>
          </h2>
          <p className="mt-6 text-white/65 max-w-xl leading-relaxed">
            $LA28 is a fair launch on{" "}
            <span className="text-[#FFD700] font-semibold">pump.fun</span>. 100%
            open bonding curve — every soldier buys on the same line.
          </p>
        </div>

        <div className="mt-16 grid lg:grid-cols-2 gap-10 items-center">
          {/* Pie chart */}
          <div
            data-testid="tokenomics-chart"
            className="card-neon p-8 sm:p-10"
          >
            <div className="aspect-square max-w-md mx-auto relative">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={DATA}
                    dataKey="value"
                    innerRadius="58%"
                    outerRadius="88%"
                    stroke="#05050A"
                    strokeWidth={4}
                    paddingAngle={2}
                  >
                    {DATA.map((d) => (
                      <Cell key={d.name} fill={d.color} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                <div className="font-mono text-[10px] tracking-[0.3em] text-white/50">
                  TOTAL
                </div>
                <div className="font-heading text-3xl font-black text-white">
                  1B
                </div>
                <div className="font-mono text-[10px] tracking-[0.3em] text-[#FFD700]">
                  $LA28
                </div>
              </div>
            </div>

            <div className="mt-8 grid grid-cols-1 gap-3">
              {DATA.map((d) => (
                <div
                  key={d.name}
                  data-testid={`tokenomics-legend-${d.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
                  className="flex items-center gap-3 text-sm"
                >
                  <span
                    className="w-3 h-3 shrink-0"
                    style={{
                      background: d.color,
                      boxShadow: `0 0 12px ${d.color}`,
                    }}
                  />
                  <div className="flex-1 min-w-0">
                    <div className="text-white/80 truncate">{d.name}</div>
                  </div>
                  <div className="font-mono text-white font-semibold">
                    {d.value}%
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Stats */}
          <div className="grid gap-4">
            {STATS.map((s, i) => (
              <div
                key={s.label}
                data-testid={`tokenomics-stat-${i}`}
                className="card-neon p-7 flex items-center justify-between"
              >
                <div>
                  <div className="font-mono text-[10px] tracking-[0.32em] text-white/50">
                    {s.label}
                  </div>
                  <div className="mt-2 font-heading text-2xl sm:text-3xl font-black text-white">
                    {s.value}
                  </div>
                </div>
                <div className="font-mono text-[10px] tracking-[0.3em] text-[#00F0FF] text-right">
                  {s.suffix}
                </div>
              </div>
            ))}
            <div className="card-neon p-7">
              <div className="font-mono text-[10px] tracking-[0.32em] text-white/50">
                TAXES
              </div>
              <div className="mt-2 font-heading text-2xl sm:text-3xl font-black text-[#FFD700] glow-gold">
                0 / 0
              </div>
              <p className="mt-2 text-sm text-white/55">
                Zero buy tax. Zero sell tax. LP auto-migrates to Raydium and
                burns at bonding curve completion.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
